module.exports = __webpack_public_path__ + "img/logo.fec3342d.png";